<div class="my-2">
  <div class="grid gap-2">
    @for (item of compareItems(); track $index) {
      <div>
        <div>
          <app-compare-print-item [level]="item.key" [item]="item.item"></app-compare-print-item>
        </div>
      </div>
    }
  </div>
</div>
